export const numberValue = (value: string | number): number => {
  const numeric =
    typeof value === 'number' ? value : parseFloat(String(value).trim());
  if (!isFinite(numeric) || isNaN(numeric) || numeric < 0) {
    return 0;
  }
  return numeric;
};
